module.exports = __webpack_public_path__ + "static/media/bar2.28ea7388.svg";